import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel,
  Permission
} from "../../shared/config";
import { SharedVehicleGroupService } from "../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { SharedVehicleGroupModel } from "../../sharedvehiclegroup/models/sharedvehiclegroup.model";

@Component({
  selector: "wego-booking-svg-popup",
  template: require('../views/booking-svg-popup.component.html'),
  providers: [SharedVehicleGroupService]
})
export class BookingSvgPopupComponent implements OnInit, OnChanges {
  permissionName: string;
  companyHashIdList: string = "";
  SelectedNames: string[] = [];
  SelectedList: string[] = [];
  DataListModel: DataListModel;
  svgList: SharedVehicleGroupModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  LblIcon: string = "fa fa-plus-square";
  isParentCheck: boolean = false;

  @Output("OnSuccessSelect") onSuccessSelect = new EventEmitter();
  @ViewChild("svgModal") public svgModal: any;

  constructor(
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["groupName", "companyName"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(
    SelectedList: string[],
    SelectedNameList: string[],
    companyHashId: string,
    permission: string
  ): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.SelectedList = SelectedList;
    this.SelectedNames = SelectedNameList;
    this.companyHashIdList = companyHashId;
    this.permissionName =permission;
    this.GetSvgList();
    this.svgModal.show();
  }

  public hide(): void {
    this.svgModal.hide();
  }

  private GetSvgList() {
    this.isLoading = true;
    this.sharedVehicleGroupService
      .GetSharedVehicleGroupList(
        this.DataListModel,
        this.companyHashIdList,
        null,
        null,
        this.permissionName
      )
      .subscribe(
        res => {
          this.svgList = res.data;
          this.svgList.forEach(
            x =>
              (x.isChecked =
                this.SelectedList.indexOf(x.sharedvehiclegroupHashId) > -1)
          );
          this.isParentCheck = this.svgList.every(x => x.isChecked);
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private select(svg: SharedVehicleGroupModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({
      SvgMasterHashID: svg.sharedvehiclegroupHashId,
      SvgName: svg.groupName
    });
    this.isLoading = false;
    this.hide();
  }

  private selectMultiple(): void {
    this.isLoading = true;

    this.onSuccessSelect.emit({
      SvgMasterHashID: this.SelectedList,
      SvgName: this.SelectedNames
    });
    this.isLoading = false;
    this.hide();
  }

  private ItemCheckChanged(
    SvgMasterHashID: string,
    svgName: string,
    isChecked: any
  ) {
    if (isChecked) {
      if (this.SelectedList.indexOf(SvgMasterHashID) == -1) {
        this.SelectedList.push(SvgMasterHashID);
      }
      if (this.SelectedNames.indexOf(svgName) == -1) {
        this.SelectedNames.push(svgName);
      }
      this.isParentCheck = this.svgList
        .filter(x => x.sharedvehiclegroupHashId != SvgMasterHashID)
        .every(x => x.isChecked);
    } else {
      this.SelectedList = this.SelectedList.filter(x => x != SvgMasterHashID);
      this.SelectedNames = this.SelectedNames.filter(x => x != svgName);
      this.isParentCheck = false;
    }
  }

  public OnParentCheck(isChecked: boolean) {
    this.svgList.forEach(x => {
      x.isChecked = isChecked;
      if (isChecked) {
        if (this.SelectedList.indexOf(x.sharedvehiclegroupHashId) == -1) {
          this.SelectedList.push(x.sharedvehiclegroupHashId);
        }
        if (this.SelectedNames.indexOf(x.groupName) == -1) {
          this.SelectedNames.push(x.groupName);
        }
      } else {
        this.SelectedList = this.SelectedList.filter(
          y => y != x.sharedvehiclegroupHashId
        );
        this.SelectedNames = this.SelectedNames.filter(y => y != x.groupName);
      }
    });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSvgList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetSvgList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSvgList();
  }
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSvgList();
  }
  private OnSuccessSelect() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-svg-popup.component.ts